<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedEquipment">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.EQUIPMENTS' | translate }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [required]="required"
    [disabled]="disabled"
    placeholder="{{ 'MAINTENANCES.EQUIPMENT_PLACEHOLDER' | translate }}"
    fxFlex="90"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedEquipment()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let equipment of equipments" [value]="equipment.id">
      <span> {{ equipment.name }} </span>
      <span class="gray" *ngIf="equipment.number"> - {{ equipment.number }} </span>
      <small class="gray" *ngIf="equipment.notes"> - {{ equipment.notes }} </small>
    </mat-option>
    <mat-option *ngIf="!equipments.length">
      {{ 'MAINTENANCES.EQUIPMENT_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    <span *ngIf="inputValue.hasError('required')">{{ 'MAINTENANCES.ERRORS.EQUIPMENT_REQUIRED' | translate }}</span>
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" fxFlex *ngIf="selectedEquipment">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.EQUIPMENTS' | translate }}</mat-label>
  <input type="text" matInput [value]="selectedEquipment?.name + ' - ' + selectedEquipment?.number" disabled required />
  <button
    mat-icon-button
    fxFlex="10"
    [disabled]="disabled"
    *ngIf="selectedEquipment"
    class="my-cancel-button accent-700-fg"
    (click)="unselectEquipment()"
  >
    <mat-icon>cancel</mat-icon>
  </button>
</mat-form-field>
